import { graphQLIdDecoder } from 'helpers/graphql-utils';
import { Steven } from 'helpers/steven';
import { type CrudAction } from 'types/steven';

type EntityTypes =
  | 'checklist_template'
  | 'checklist_template_field'
  | 'checklist_template_question'
  | 'checklist_template_section';

type FireStevenEntityCrudEventForTemplateArgs = {
  templateNodeId: string;
  entityType?: EntityTypes;
  action?: CrudAction;
};

/**
 * Fire Steven EntityCRUD Event for Template Update
 * @param {string} templateNodeId - The Graphql Node ID of the checklist template that was modified.
 * @param {EntityTypes} entityType - The entity type of the template that was modified.
 * @param {CrudAction} action - The crud action that was performed on the template.
 */
export const fireStevenEntityCrudEventForTemplate = ({
  templateNodeId,
  entityType = 'checklist_template',
  action = 'updated',
}: FireStevenEntityCrudEventForTemplateArgs) => {
  const templateDbId = graphQLIdDecoder(templateNodeId).databaseId;

  Steven.entityCrud({
    entity_id: templateDbId.toLocaleString(),
    entity_type: entityType,
    action,
  });
};
